/* @flow */

import { combineReducers } from 'redux';

import marketQueryReducer from './marketQueryReducer';
import marketKeywordsReducer from './marketKeywordsReducer';

// $FlowIssue
const marketSearchReducer = combineReducers({
  query: marketQueryReducer,
  keywords: marketKeywordsReducer,
});

export default marketSearchReducer;
